function formatPlurial(isPlurial: boolean) {
  return isPlurial ? 's' : '';
}

export function getCommentariesLabel(
  authors: string[] = [],
  hiddenAuthors: number = 0,
) {
  const authorsCleaned = authors.map(author => author.slice(0, 40));
  const numberOfAuthors = authors.length + hiddenAuthors;

  let authorsPart = '';
  let subjectPart = '';

  if (authors.length === 1) {
    authorsPart = authorsCleaned[0];
  } else if (authorsCleaned.length > 1 && hiddenAuthors === 0) {
    const lastAuthor = authorsCleaned.pop();
    authorsPart = `${authorsCleaned.join(', ')} et ${lastAuthor} `;
  } else {
    authorsPart = authorsCleaned.join(', ');
  }

  if (hiddenAuthors > 0) {
    const plurial = hiddenAuthors > 1;
    subjectPart += ` et ${hiddenAuthors} autre${formatPlurial(
      plurial,
    )} auteur${formatPlurial(plurial)} `;
  }

  subjectPart += `${
    numberOfAuthors > 1 ? 'ont' : ' a'
  } également commenté cette décision`;

  return authorsPart + subjectPart;
}
